// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1Tyw_","wrapper":"header_wrapper__2KWKV","logo":"header_logo__P0P8F"};